import Vue from 'vue'
import Router from 'vue-router'
import Inicio from '@/components/Inicio'
//Empleados (es lo mismo que usuarios que tendrán acceso a la plataforma)
import EmpleadosListado from '@/components/empleados/EmpleadosListado'
import EmpleadosNuevo from '@/components/empleados/EmpleadosNuevo'
//Categorias de las publicaciones
import CategoriasListado from '@/components/categorias/CategoriasListado'
//Publicaciones
import PublicacionesListado from '@/components/publicaciones/PublicacionesListado'
import PublicacionesNueva from '@/components/publicaciones/PublicacionesNueva'
import PublicacionesEditar from '@/components/publicaciones/PublicacionesEditar'
import PublicacionesReportes from '@/components/publicaciones/PublicacionesReportes'
//Sitios de interés
import SitiosListado from '@/components/sitios/SitiosListado'
//Suscripcones
import SuscripcionesPrecio from '@/components/suscripciones/SuscripcionesPrecio'
//Usuarios
import UsuariosListado from '@/components/usuarios/UsuariosListado'
import UsuariosDetalleCuenta from '@/components/usuarios/UsuariosDetalleCuenta'
//Sesion
import Login from '@/components/Login'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Inicio',
    component: Inicio
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  }, {
    path: '/categorias',
    name: 'CategoriasListado',
    component: CategoriasListado
  }, {
    path: '/empleados',
    name: 'EmpleadosListado',
    component: EmpleadosListado
  }, {
    path: '/empleado/nuevo',
    name: 'EmpleadosNuevo',
    component: EmpleadosNuevo
  }, {
    path: '/publicaciones',
    name: 'PublicacionesListado',
    component: PublicacionesListado
  }, {
    path: '/publicacion/nueva',
    name: 'PublicacionesNueva',
    component: PublicacionesNueva
  }, {
    path: '/publicacion/:publicacion/editar',
    name: 'PublicacionesEditar',
    component: PublicacionesEditar
  }, {
    path: '/publicaciones/reporte',
    name: 'PublicacionesReportes',
    component: PublicacionesReportes
  }, {
    path: '/sitios',
    name: 'SitiosListado',
    component: SitiosListado
  }, {
    path: '/suscripciones/precios',
    name: 'SuscripcionesPrecio',
    component: SuscripcionesPrecio
  }, {
    path: '/suscripciones/cuentas',
    name: 'UsuariosListado',
    component: UsuariosListado
  }, {
    path: '/suscripcion/cuenta/:cuenta',
    name: 'UsuariosDetalleCuenta',
    component: UsuariosDetalleCuenta
  }, ]
})